import { createApiClient } from "@carepass/api-client";
import { createAsyncTaskRegistry } from "@carepass/async-task";
import {
  bearerToken,
  createPartnerJoinStore,
  createSessionStore,
} from "@carepass/auth";
import { createRuntimeConfig, type RuntimeEnvironment } from "@carepass/config";
import { createBrowserRouter } from "@carepass/routing";
import { memberNotFoundRoute, memberRoutes } from "./routes";
import { clearTransferDrafts } from "../features/member/transaction-transfer-request";

const injectedEnvironment = (window as Window & { __CAREPASS_RUNTIME_CONFIG__?: RuntimeEnvironment }).__CAREPASS_RUNTIME_CONFIG__;

export const runtimeConfig = createRuntimeConfig({
  VITE_CAREPASS_PROFILE: import.meta.env.VITE_CAREPASS_PROFILE,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_ASYNC_POLL_INITIAL_DELAY_MS: import.meta.env.VITE_ASYNC_POLL_INITIAL_DELAY_MS,
  VITE_ASYNC_POLL_MAX_DELAY_MS: import.meta.env.VITE_ASYNC_POLL_MAX_DELAY_MS,
  VITE_ASYNC_POLL_TIMEOUT_MS: import.meta.env.VITE_ASYNC_POLL_TIMEOUT_MS,
  ...injectedEnvironment,
}, window.location);

export const memberSessionStore = createSessionStore({
  scope: "member",
  persistence: "tab",
  storage: window.sessionStorage,
  persistRefreshToken: false,
});
memberSessionStore.subscribe(change => { if (!change.session) clearTransferDrafts(); });

export const partnerJoinStore = createPartnerJoinStore(window.sessionStorage);
export const directSignupStore = createPartnerJoinStore(
  window.sessionStorage,
  Date.now,
  "carepass.direct.signup.v1",
);
export const memberAsyncTasks = createAsyncTaskRegistry(window.sessionStorage);

export const publicApiClient = createApiClient({ baseUrl: runtimeConfig.apiBaseUrl });
export const partnerApiClient = createApiClient({ baseUrl: runtimeConfig.apiBaseUrl });
export const memberApiClient = createApiClient({
  baseUrl: runtimeConfig.apiBaseUrl,
  getAccessToken: () => bearerToken(memberSessionStore),
  onUnauthorized: () => memberSessionStore.clear(),
});

export const memberRouter = createBrowserRouter({
  window,
  routes: memberRoutes,
  fallback: memberNotFoundRoute,
});
